<template>
  <div>
    <v-card class="ma-3">
      <g-overlay :is-relay="isOverlay"/>
      <page-progress v-bind:is-loading="isLoading"/>
      <page-title icon="mdi-cart-outline" title="Make a Invoice" :show-button="true" btn-link="/invoices"/>
      <v-container class="pt-0" fluid>
        <v-row>
          <v-col cols="12" md="5" sm="12" xl="5" xs="12">
            <v-card>
              <v-card-text>
                <v-form ref="orderFormRef" v-model="orderValid" lazy-validation>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-text-field
                          v-model="order.date"
                          dense
                          disabled
                          label="Date"
                          outlined
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model="order.name"
                          dense
                          label="Name"
                          placeholder="John Doe"
                          outlined
                      />
                    </v-col>
                    <v-col cols="12" md="9">
                      <v-text-field
                          v-if="!isExists"
                          v-model="order.email"
                          :rules="requiredEmailRule"
                          dense
                          label="Email"
                          outlined
                          class="mr-2"
                          :label="!showClientInnerIcon ? 'Email' : ''"
                          :prepend-inner-icon="showClientInnerIcon"
                          @change="clientHandler(order.email)"
                      />
                      <g-p-auto-complete
                          v-if="isExists"
                          :dense="true"
                          :outlined="true"
                          v-model="order.email"
                          :validation="true"
                          apiPath="invoice/get-all-email"
                          item-text="email"
                          item-value="email"
                          search-label="Select a Email"
                          :search-label="!showClientInnerIcon ? 'Select a Email' : ''"
                          :inner-icon="showClientInnerIcon"
                          @clearSearchResult="handleClearSearchResultEmail"
                          @selectSearchResult="onSelectionsEmailHandler"
                          class="mr-2"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-checkbox
                          class="checkbox-mr-top"
                          v-model="isExists"
                          label="Is Exists?"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-select
                          v-model="order.billingType"
                          :items="['Guest Post', 'Link Insert', 'Article Writing and Publishing', 'Guest Post and Link Insert Both', 'Home Page Link Insertion on']"
                          :rules="requiredFieldRule"
                          label="Billing Type"
                          outlined
                          dense
                      />
                    </v-col>
                    <v-col cols="12" v-if="invoiceDueInfo.length > 0">
                      <due-data-table :due-data="invoiceDueInfo"/>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="7" sm="12" xl="7" xs="12">
            <v-card>
              <v-card-text>
                <v-form ref="cartFormRef" v-model="formValid" lazy-validation>
                  <v-row dense no-gutters>
                    <v-col cols="12" md="12">
                      <g-p-auto-complete
                          :dense="true"
                          :outlined="true"
                          :search-value="product.site"
                          :status=true
                          :validation="false"
                          apiPath="sites"
                          class="mr-2"
                          item-text="siteUrl"
                          search-label="Select a Site"
                          sort-by="site_url"
                          @clearSearchResult="handleClearSearchResult"
                          @selectSearchResult="onSelections"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                          class="mr-2"
                          v-model="product.customEntityName"
                          dense
                          label="Custom Entity Name"
                          outlined
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                          v-model="product.price"
                          :rules="priceRule"
                          class="right-align-text"
                          dense
                          label="Price"
                          onclick="this.select()"
                          outlined
                          type="number"
                          @input="inputPriceHandler()"
                      />
                    </v-col>
                    <v-col cols="12" md="12" v-if="order.billingType === 'Article Writing and Publishing'">
                      <v-text-field
                          v-model="product.articleWritingPrice"
                          :rules="priceRule"
                          class="right-align-text"
                          dense
                          label="Article Writing Price"
                          onclick="this.select()"
                          outlined
                          type="number"
                          @input="inputPriceHandler()"
                      />
                    </v-col>
                    <template v-for="(item, key) in linkInsertions"
                              v-if="order.billingType === 'Link Insert' || isBillingTypeBoth">
                      <v-col cols="12" md="4">
                        <v-text-field
                            v-model="item.anchorText"
                            label="Anchor Text"
                            class="mr-2"
                            outlined
                            dense
                        />
                      </v-col>
                      <v-col cols="12" md="7">
                        <v-text-field
                            v-model="item.url"
                            label="URL"
                            class="mr-2"
                            outlined
                            dense
                        />
                      </v-col>
                      <v-col cols="12" md="1">
                        <v-btn
                            v-if="key !==0"
                            color="error"
                            icon
                            @click="linkInsertionRowRemoveHandler(key)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <v-btn
                            v-if="linkInsertions.length === key + 1 && !(linkInsertions.length >= 10)"
                            color="primary"
                            fab
                            x-small
                            @click="linkInsertionRowHandler()"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </template>
                    <v-col cols="12" md="12">
                      <v-textarea
                          v-model="product.liveLink"
                          :rules="requiredFieldRule"
                          dense
                          label="Live Link"
                          outlined
                          rows="2"
                          @input="checkLiveLinks()"
                      />
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="order.billingType === 'Guest Post and Link Insert Both'">
                      <v-checkbox
                          class="checkbox-mr-top"
                          v-model="isBillingTypeBoth"
                          label="Is Link Insert?"
                      />
                    </v-col>
                    <v-col cols="12" sm="12" md="8">
                      <v-checkbox
                          v-model="isCheckedAdultPrice"
                          label="Other Post Price"
                          color="indigo"
                          hide-details
                          @change="onCheckboxAdultHandler()"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                          v-model="product.total"
                          :rules="priceRule"
                          class="right-align-text"
                          dense
                          label="Total"
                          outlined
                          readonly
                          type="number"
                      />
                    </v-col>
                  </v-row>
                </v-form>
                <v-card-actions>
                  <v-spacer/>
                  <add-button
                      text="Add to Cart"
                      @onButtonClick="addToCartHandler"
                  />
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12" sm="12" xl="7" xs="12">
            <v-card>
              <v-card-text>
                <v-checkbox v-model="isAddBulkLink" label="Bulk Link"/>
                <template v-if="isAddBulkLink">
                  <v-checkbox
                      class="mb-5"
                      v-model="isBulkCheckedAdultPrice"
                      label="Other Post Price"
                      color="indigo"
                  />
                  <v-textarea
                      v-model="bulkLiveLink"
                      label="Bulk Link"
                      placeholder="Paste Live Link Here....."
                      outlined
                      dense
                      rows="4"
                      @input="bulkLiveLinkHandler($event)"
                  />
                </template>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12" sm="12" xl="12" xs="12">
            <v-card>
              <v-data-table
                  :headers="headers"
                  :items="getCarts"
                  hide-default-footer
                  :disable-pagination="true"
              >
                <template v-slot:footer>
                  <v-divider/>
                  <v-toolbar flat>
                    <v-spacer/>
                    <cancel-button @onButtonClick="onCancelInvoice"/>
                    <confirm-button
                        text="Confirm"
                        :disabled="!carts.length || (order.paymentMethod === 12 && !order.description)"
                        @onButtonClick="onConfirmHandler"
                    />
                  </v-toolbar>
                </template>
                <template v-slot:body.append>
                  <tr color="red">
                    <td colspan="9" style="text-align: right">
                      <h3>Sub Total</h3>
                    </td>
                    <td style="text-align: right"><h4>${{ subTotal }} USD</h4></td>
                    <td></td>
                  </tr>
                  <tr color="red">
                    <td colspan="9" style="text-align: right">
                      <h3>Discount</h3>
                    </td>
                    <td style="text-align: right">
                      <v-text-field
                          v-model="order.discount"
                          :rules="requiredFieldRule"
                          type="number"
                          onclick="this.select()"
                          class="right-align-text discount-field mt-2 mb-1"
                          dense
                          outlined
                      />
                    </td>
                    <td></td>
                  </tr>
                  <tr color="red">
                    <td colspan="9" style="text-align: right">
                      <h3>Grand Total</h3>
                    </td>
                    <td style="text-align: right"><h4>${{ grandTotal }} USD</h4></td>
                    <td></td>
                  </tr>
                  <tr color="red" v-if="order.paymentMethod === 12 || order.paymentMethod === 13">
                    <td colspan="9" style="text-align: right">
                      <h3>Name(Required if BD payment)</h3>
                    </td>
                    <td>
                      <v-text-field
                          v-model="order.name"
                          :rules="requiredFieldRule"
                          dense
                          label="Client Name(Required if BD payment)"
                          placeholder="John Doe"
                          outlined
                          class="discount-field mt-2 mb-1"
                      />
                    </td>
                    <td></td>
                  </tr>
                  <tr color="red" v-if="order.paymentMethod === 12 || order.paymentMethod === 13">
                    <td colspan="9" style="text-align: right">
                      <h3>Phone(Required if BD payment)</h3>
                    </td>
                    <td>
                      <v-text-field
                          type="text"
                          v-model="order.phone"
                          :rules="requiredFieldRule"
                          dense
                          placeholder="01711xxxxxx"
                          outlined
                          class="discount-field mt-2 mb-1"
                      />
                    </td>
                    <td></td>
                  </tr>
                  <tr color="red" v-if="order.paymentMethod === 12 || order.paymentMethod === 13">
                    <td colspan="9" style="text-align: right">
                      <h3>Description(Required if BD payment)</h3>
                    </td>
                    <td>
                      <div class="content-edit-box">
                        <div
                            contenteditable="true"
                            class="contentEditTableBox"
                            ref="editTableBoxDetails"
                            v-html="ediTableContent"
                            @input="handleEditableInput($event)"
                        />
                      </div>
                      <span style="color: red;" v-if="!order.description">This field is required for BD payment</span>
                    </td>
                    <td></td>
                  </tr>
                  <tr color="red" v-else>
                    <td colspan="9" style="text-align: right">
                      <h3>Description(Required if BD payment)</h3>
                    </td>
                    <td>
                      <div class="content-edit-box">
                        <div
                            contenteditable="true"
                            class="contentEditTableBox"
                            ref="editTableBoxDetails"
                            v-html="ediTableContent"
                            @input="handleEditableInput($event)"
                        />
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr color="red">
                    <td colspan="9" style="text-align: right">
                      <h3>Pay Method</h3>
                    </td>
                    <td style="text-align: right">
                      <v-select
                          v-model="order.paymentMethod"
                          :items="paymentMethods"
                          :rules="requiredFieldRule"
                          item-text="name"
                          item-value="id"
                          class="discount-field mt-2 mb-1"
                          dense
                          outlined
                      />
                    </td>
                    <td></td>
                  </tr>
                  <tr color="red">
                    <td colspan="9" style="text-align: right">
                      <h3>Is Send Mail?</h3>
                    </td>
                    <td>
                      <v-checkbox
                          v-model="order.isSendMail"
                      />
                    </td>
                    <td></td>
                  </tr>
                </template>
                <template v-slot:top>
                  <v-toolbar dense flat>
                    Carts
                  </v-toolbar>
                </template>
                <template v-slot:no-data>
                  Cart is empty!
                </template>
                <template v-slot:item.liveLink={item}>
                  <v-chip
                      class="ma-2"
                      color="green"
                      link
                      text-color="white"
                      @click.prevent.stop="liveLinkHandler(item)"
                  >
                    View Live Link
                  </v-chip>
                </template>
                <template v-slot:item.linkInsertions={item}>
                  <v-chip
                      v-if="order.billingType === 'Link Insert' || order.billingType === 'Guest Post and Link Insert Both'"
                      class="ma-2"
                      color="lime"
                      link
                      text-color="white"
                      @click.prevent.stop="linkInsertionPopupHandler(item)"
                  >
                    View Links
                  </v-chip>
                </template>
                <template v-slot:item.adultPrice={item}>
                  <div class="price-field">
                    <v-text-field
                        :hide-details="true"
                        :value="item.adultPrice"
                        class="right-align-text"
                        dense
                        onclick="this.select()"
                        outlined
                        type="number"
                        @input="onAdultHandler(item.id, $event)"
                    />
                  </div>
                </template>
                <template v-slot:item.price={item}>
                  <div class="price-field">
                    <v-text-field
                        :hide-details="true"
                        :value="item.price"
                        class="right-align-text"
                        dense
                        onclick="this.select()"
                        outlined
                        type="number"
                        @input="onPriceHandler(item.id, $event)"
                    />
                  </div>
                </template>
                <template v-slot:item.articleWritingPrice={item}>
                  <div class="price-field">
                    <v-text-field
                        :hide-details="true"
                        :value="item.articleWritingPrice"
                        class="right-align-text"
                        dense
                        onclick="this.select()"
                        outlined
                        type="number"
                        :disabled="order.billingType !== 'Article Writing and Publishing'"
                        @input="onArticleWritingHandler(item.id, $event)"
                    />
                  </div>
                </template>
                <template v-slot:item.total={item}>
                  {{ getAmountWithSymbol(item.total) }}
                </template>
                <template v-slot:item.actions={item}>
                  <v-btn
                      color="error"
                      icon
                      @click="confirmToDeleteItem(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <link-insertions-popup
            :item="currentItem"
            :show="showLinkInsertionPopup"
            @closePopupHandler="closePopupHandler"
            @updateLinkInsertionHandler="updateLinkInsertionHandler"
        />
        <view-live-link
            :item="currentItem"
            :show="showLiveLink"
            @onLinkUpdateHandler="onLinkUpdateHandler"
            @closePopupHandler="closePopupHandler"
        />
        <confirm-popup
            :show="showItemDeleteConfirm"
            confirm-event="onConfirmDelete"
            @closePopupHandler="showItemDeleteConfirm = false"
            @onConfirmDelete="confirmDelete()"
        >
        <span
        >Are you sure to remove
        <b>{{ this.deleteItem ? this.deleteItem.siteUrl : "" }}</b> from cart?</span
        >
        </confirm-popup>
        <confirm-popup
            :show="showOrderConfirm"
            confirm-event="onConfirmOrder"
            @closePopupHandler="showOrderConfirm = false"
            @onConfirmOrder="onConfirmHandler(true)"
        >
          <div>
        <span>Are you sure to confirm the order amount of
          <b>$ {{ grandTotal }}, </b>
          from <i>{{ order.email && order.email ? order.email : " " }}</i> ?
       </span>
          </div>
        </confirm-popup>
        <mail-template-popup
            :show="showMailTemplate"
            :item="{...order, carts}"
            @closeMailPopupHandler="closeLinkPopupHandler"
        />
        <confirm-popup
            :show="showBlockedClient"
            :show-save-button="false"
            @closePopupHandler="showBlockedClient = false"
        >
          <div>
            {{`This email: [${this.blockedClientInfo ? this.blockedClientInfo.email : ''}] is currently blocked. Invoice creation is not allowed at this time.`}}<br>
            Reason: {{this.blockedClientInfo ? this.blockedClientInfo.description: ''}}
          </div>
        </confirm-popup>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import PageProgress from "../components/PageProgress";
import PageTitle from "../components/PageTitle";
import GPAutoComplete from "../components/GPAutoComplete";
import AddButton from "../components/buttons/AddButton";
import Validation from "../components/mixins/Validation";
import ConfirmPopup from "../components/popups/ConfirmPopup";
import CancelButton from "../components/buttons/CancelButton";
import ConfirmButton from "../components/buttons/ConfirmButton";
import MailTemplatePopup from "../components/popups/MailTemplatePopup";
import ViewLiveLink from "../components/popups/ViewLiveLink";
import InvoiceMixins from "./mixins/InvoiceMixins";
import GOverlay from "./GOverlay";
import LinkInsertionsPopup from "./popups/LinkInsertionsPopup";
import DueDataTable from "./invoice/DueDataTable";

export default {
  name: "GInvoice",
  components: {
    LinkInsertionsPopup,
    GOverlay,
    ViewLiveLink,
    MailTemplatePopup,
    ConfirmButton,
    CancelButton,
    ConfirmPopup,
    AddButton,
    GPAutoComplete,
    PageTitle,
    PageProgress,
    DueDataTable
  },
  mixins: [Validation, InvoiceMixins],
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Panel - Invoice | %s',
    meta: [
      {name: 'robots', content: 'noindex'},
      {name: 'googlebot', content: 'noindex'}
    ]
  }
}
</script>

<style lang="scss">
.price-field .v-input {
  max-width: 200px;
  float: right;
  align-items: center;
}

.discount-field .v-text-field__details {
  padding-top: 0px !important;
  margin-bottom: 0px !important;
  display: none;
}

.checkbox-mr-top {
  margin-top: 2px !important;
}
</style>